export interface RememberedLogin {
    email: string;
    password: string;
}

const REMEMBERED_LOGINS_KEY = 'rememberedLogins';

export const getRememberedLogins = (): RememberedLogin[] => {
    try {
        const stored = localStorage.getItem(REMEMBERED_LOGINS_KEY);

        if (!stored) {
            return [];
        }

        const parsed = JSON.parse(stored);

        if (!Array.isArray(parsed)) {
            return [];
        }

        return parsed.filter(
            (account): account is RememberedLogin =>
                typeof account?.email === 'string' &&
                typeof account?.password === 'string'
        );
    } catch (error) {
        console.error('Failed to get remembered logins:', error);
        return [];
    }
};

export const rememberLogin = (
    email: string,
    password: string
): void => {
    try {
        const accounts = getRememberedLogins();

        const filteredAccounts = accounts.filter(
            account =>
                account.email.toLowerCase() !== email.toLowerCase()
        );

        const updatedAccounts: RememberedLogin[] = [
            ...filteredAccounts,
            {
                email,
                password,
            },
        ];

        localStorage.setItem(
            REMEMBERED_LOGINS_KEY,
            JSON.stringify(updatedAccounts)
        );
    } catch (error) {
        console.error('Failed to remember login:', error);
    }
};

export const removeRememberedLogin = (
    email: string
): void => {
    try {
        const accounts = getRememberedLogins();

        const filteredAccounts = accounts.filter(
            account =>
                account.email.toLowerCase() !== email.toLowerCase()
        );

        localStorage.setItem(
            REMEMBERED_LOGINS_KEY,
            JSON.stringify(filteredAccounts)
        );
    } catch (error) {
        console.error('Failed to remove remembered login:', error);
    }
};

export const clearRememberedLogins = (): void => {
    try {
        localStorage.removeItem(REMEMBERED_LOGINS_KEY);
    } catch (error) {
        console.error('Failed to clear remembered logins:', error);
    }
};